import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';
import { DateUtil } from 'src/app/share/utils/date-util';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payroll-break',
  templateUrl: './payroll-break.component.html',
  styleUrls: ['./payroll-break.component.scss']
})
export class PayrollBreakComponent implements OnInit {

  constructor(private commonService: CommonService, private authService: AuthService, private router: Router) { }

  vm$: Observable<any>
  private cmd$ = new BehaviorSubject<IPayrollBreakCommand>({ load: true });
  dataLoadCompleted: boolean = false;
  payrollPeriodId: number = 0;


  ngOnInit(): void {
    this.loadPage$();
  }

  loadPage$() {
    this.vm$ = this.cmd$.pipe(
      switchMap(cmd => {
        if (cmd.load) {
          return this.commonService.getData('PageCommand', 'home', 'load-timesheet-page', { driverCode: this.authService.currentState()?.user?.driverCode }, '/api/ChauffeurPortal').pipe(
            map((v: IViewModelPayrollBreak) => {
              this.dataLoadCompleted = v.workingText ? false : true;
              if (v.workingText)
                return { ...v };

              const ret = { ...v, actionsAllowed: false };
              if (ret.data) {
                ret.breakEditFormVm = undefined;

                ret.pendingRealTimesBreaksVm = undefined;
                if (ret.data?.pendingRealTimesBreaks && !ret.data?.pendingRealTimesBreaks[0]?.unauthorized) {
                  ret.pendingRealTimesBreaksVm = {
                    breaksSupported: ret.data.pendingRealTimesBreaks.breaksSupported,
                    mealBreakAllowed: ret.data.pendingRealTimesBreaks.mealBreakAllowed,
                    restBreakAllowed: ret.data.pendingRealTimesBreaks.restBreakAllowed,
                    restBreakSupported: ret.data.pendingRealTimesBreaks.restBreakSupported,
                    restBreakEndAllowed: ret.data.pendingRealTimesBreaks.restBreakEndAllowed,
                    mealBreakEndAllowed: ret.data.pendingRealTimesBreaks.mealBreakEndAllowed,
                    mealBreakSupported: ret.data.pendingRealTimesBreaks.mealBreakSupported,
                    payrollPeriodDriverDayId: ret.data.pendingRealTimesBreaks.payrollPeriodDriverDayId
                  }
                }
                ret.completedRealTimesBreaksVm = undefined;
                if (ret.data?.completedRealTimesBreaks && !ret.data?.completedRealTimesBreaks[0]?.unauthorized && ret.data.completedRealTimesBreaks.payrollPeriodDriverDayId) {
                  const breaks: IClockedInData[] = JSON.parse(ret.data.completedRealTimesBreaks.data || '[]');
                  const breaksFiltered = (breaks ?? []).filter((b: IClockedInData) => b.editStatus && b.editStatus.toLowerCase() !== 'deleted');
                  if ((breaksFiltered ?? []).length > 0) {
                    ret.completedRealTimesBreaksVm = {
                      payrollPeriodDriverDayId: ret.data.completedRealTimesBreaks.payrollPeriodDriverDayId,
                      data: breaksFiltered
                    }
                  }
                }
                ret.pendingSignatureVm = undefined;
                if (ret.data?.pendingSignature) {
                  ret.pendingSignatureVm = {
                    rows: ret.data.pendingSignature.rows.map(r => ({
                      daysWaiting: r.daysWaiting,
                      issuesCount: r.issuesCount,
                      issues: JSON.parse(r.issuesJson),
                      payrollDate: new Date(r.payrollDate),
                      payrollPeriodDriverDayId: r.payrollPeriodDriverDayId,
                      payrollPeriodDriverDayTimesheetId: r.payrollPeriodDriverDayTimesheetId
                    }))
                  }
                }
              }
              console.log('loadPage', ret);
              return ret;
            })
          );
        } else {
          return merge(

            // prep
            of(cmd).pipe(
              map(cmd => {

                const ret = { ...cmd.viewModel, actionsAllowed: false };

                // if (cmd.invokeBreakClockInOut) {
                //   cmd.viewModel.completedRealTimesBreaksVm.cmdExecutingText = 'Validating...';
                // }
                return ret;
              })
            ),

            // invoke API
            of(cmd).pipe(

              // invoke server comand
              switchMap((cmd) => {

                if (cmd.invokeBreakClockInOut)
                  return this.executeAction$(cmd);
                else if (cmd.invokeDriverUpdateBreak)
                  return this.executeAction$(cmd);
                else if (cmd.invokeGetPayrollPeriodBreaks)
                  return this.executeAction$(cmd);
                else
                  throw 'unknown command';
              })
            )
          );
        }
      })
    );
  }

  private executeAction$(cmd: IPayrollBreakCommand): Observable<IViewModelPayrollBreak> {
    return this.commonService.getData('PageCommand', 'home', cmd.actionName, { id: cmd.id, breaks: cmd.breaks, driverCode: this.authService.currentState()?.user?.driverCode, dataJson: cmd.dataJson }, '/api/ChauffeurPortal').pipe(
      map((r: IPayrollBreakCommandResult) => {
        this.dataLoadCompleted = r.workingText ? false : true;
        if (r.workingText)
          return { ...cmd.viewModel, actionsAllowed: false };

        const ret: IViewModelPayrollBreak = { ...cmd.viewModel, actionsAllowed: true };

        console.log('executeAction', cmd.actionName, r);
        if (cmd.actionName && r.data && r.data.status == 'ok') {
          switch (cmd.actionName) {
            case 'break-clock-in-out':
              if (r.data?.completedRealTimesBreaks) {

                ret.pendingRealTimesBreaksVm = undefined;
                if (r.data?.pendingRealTimesBreaks) {
                  ret.pendingRealTimesBreaksVm = {
                    breaksSupported: r.data.pendingRealTimesBreaks.breaksSupported,
                    mealBreakAllowed: r.data.pendingRealTimesBreaks.mealBreakAllowed,
                    restBreakAllowed: r.data.pendingRealTimesBreaks.restBreakAllowed,
                    restBreakSupported: r.data.pendingRealTimesBreaks.restBreakSupported,
                    restBreakEndAllowed: r.data.pendingRealTimesBreaks.restBreakEndAllowed,
                    mealBreakEndAllowed: r.data.pendingRealTimesBreaks.mealBreakEndAllowed,
                    mealBreakSupported: r.data.pendingRealTimesBreaks.mealBreakSupported,
                    payrollPeriodDriverDayId: r.data.pendingRealTimesBreaks.payrollPeriodDriverDayId
                  }
                }
                //ret.completedRealTimesBreaksVm = undefined;
                if (r.data?.completedRealTimesBreaks && r.data.completedRealTimesBreaks.payrollPeriodDriverDayId) {
                  const breaks: IClockedInData[] = JSON.parse(r.data.completedRealTimesBreaks.data || '[]');
                  const breaksFiltered = (breaks ?? []).filter((b: IClockedInData) => b.editStatus && b.editStatus.toLowerCase() !== 'deleted');
                  if ((breaksFiltered ?? []).length > 0) {
                    ret.completedRealTimesBreaksVm = {
                      payrollPeriodDriverDayId: ret.data.completedRealTimesBreaks.payrollPeriodDriverDayId,
                      data: breaksFiltered
                    }
                  }
                }
              }
              break;
          }
        } else {

        }

        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...cmd.viewModel };

        console.log('error', e);

        return of(ret);
      })
    );
  }

  /**
   * 
   */
  refreshPage() {
    this.cmd$.next({ load: true });
    this.authService.userInRole;
  }



  restBreakClockInOut(id: number, vm: IViewModelPayrollBreak) {
    var jsonString: string = '';

    var actionType: ClockInOutActionType = 'add';
    if (vm.pendingRealTimesBreaksVm.restBreakEndAllowed) {
      actionType = 'edit';

      var breakIn = vm.completedRealTimesBreaksVm.data.find(d => !d.endAt || !d.endAt.time);
      if (!breakIn)
        return;

      const breakAction: ClockInOutBreakAction = {
        [actionType]: {
          id: breakIn.id,
          breakType: 1,
          at: DateUtil.shortDateTime(DateUtil.buildDateFromDateTimeString(breakIn.startAt.date, breakIn.startAt.time)),
          endAt: DateUtil.shortDateTime(DateUtil.now())
        }
      };
      jsonString = JSON.stringify(breakAction);
    } else {
      const breakAction: ClockInOutBreakAction = {
        [actionType]: {
          breakType: 1,
          at: DateUtil.shortDateTime(DateUtil.now())
        }
      };
      jsonString = JSON.stringify(breakAction);
    }

    this.cmd$.next({ invokeBreakClockInOut: {}, actionName: 'break-clock-in-out', id: id, viewModel: vm, dataJson: jsonString, breakType: 'rest' });
  }

  mealBreakClockInOut(id: number, vm: IViewModelPayrollBreak) {

    var jsonString: string = '';

    var actionType: ClockInOutActionType = 'add';
    if (vm.pendingRealTimesBreaksVm.mealBreakEndAllowed) {
      actionType = 'edit';

      var breakIn = vm.completedRealTimesBreaksVm.data.find(d => !d.endAt || !d.endAt.time);
      if (!breakIn)
        return;

      const breakAction: ClockInOutBreakAction = {
        [actionType]: {
          id: breakIn.id,
          breakType: 2,
          at: DateUtil.shortDateTime(DateUtil.buildDateFromDateTimeString(breakIn.startAt.date, breakIn.startAt.time)),
          endAt: DateUtil.shortDateTime(DateUtil.now())
        }
      };
      jsonString = JSON.stringify(breakAction);
    } else {
      const breakAction: ClockInOutBreakAction = {
        [actionType]: {
          breakType: 2,
          at: DateUtil.shortDateTime(DateUtil.now()),
          endAt: null
        }
      };
      jsonString = JSON.stringify(breakAction);
    }

    this.cmd$.next({ invokeBreakClockInOut: {}, actionName: 'break-clock-in-out', id: id, viewModel: vm, dataJson: jsonString, breakType: 'meal' });
  }

  onClockedInRowClick(breakId: number) {
    this.router.navigateByUrl(`/payroll/breaks/${breakId}`);
  }

  onPendingSignatureRowClick(r: IPendingSignatureRowData) {
    if (r.issuesCount > 0)
      return;

    this.router.navigateByUrl(`/payroll/timesheets/${r.payrollPeriodDriverDayTimesheetId}`);
  }
}

/**
 * 
 */
export interface IViewModelPayrollBreak extends IPageDataViewModel {
  data?: {
    pendingRealTimesBreaks: IPendingRealTimesBreaks, completedRealTimesBreaks: { payrollPeriodDriverDayId: number, data: string },
    pendingSignature: {
      rows:
      {
        daysWaiting: number;
        issuesCount: number;
        issuesJson: string;
        payrollDate: Date;
        payrollPeriodDriverDayId: number;
        payrollPeriodDriverDayTimesheetId: number;
      }[]
    }
  };

  pendingRealTimesBreaksVm: IPendingRealTimesBreaks;
  completedRealTimesBreaksVm: ICompletedRealTimesBreaks;
  pendingSignatureVm: IPendingSignature;

  breakEditFormVm?: IBreakEntryFormViewModel;

  actionsAllowed?: boolean;

}

/**
 * 
 */
interface IPendingRealTimesBreaks extends ICommandElement {
  breaksSupported: boolean;
  mealBreakAllowed: boolean;
  mealBreakEndAllowed: boolean;
  mealBreakSupported: boolean;
  restBreakAllowed: boolean;
  restBreakEndAllowed: boolean;
  restBreakSupported: boolean;
  payrollPeriodDriverDayId: number;
}

/**
 * 
 */
interface ICompletedRealTimesBreaks extends ICommandElement {
  payrollPeriodDriverDayId: number;
  data: IClockedInData[];
}

/**
 * 
 */
interface IPendingSignature {
  rows: IPendingSignatureRowData[];
}

/**
 * 
 */
interface IPendingSignatureRowData {
  daysWaiting: number;
  issuesCount: number;
  issues: ITimesheetIssue;
  payrollDate: Date;
  payrollPeriodDriverDayId: number;
  payrollPeriodDriverDayTimesheetId: number;
}

/**
 * 
 */
interface IClockedInData {
  id: number;
  breakType: number;
  startAt: { date: string, time: string };
  endAt: { date: string, time: string };
  editStatus: string;
}


/**
 * 
 */
interface IPayrollBreakCommandResult extends IPageDataViewModel {
  data: {
    status: string,
    completedRealTimesBreaks: {
      payrollPeriodDriverDayId: number,
      data: string
    }
    pendingRealTimesBreaks: IPendingRealTimesBreaks
  };
}

/**
* 
*/
export interface IPayrollBreakSectionsViewData extends ICommandElement {
  payrollDate: Date;
  payrollPeriodDriverDayId: number;
  completed: boolean;
  rows: IPayrollBreakRowData[];

  actionsAllowed: boolean;
}

/**
* 
*/
export interface IPayrollBreakRowData {
  driverDayBreakId: number;
  breakType: number;
  status: number;
  durationMinutes: number;
  startDateTime: Date;
  endDateTime: Date;
  userStatus: number;
  userDurationMinutes: number;
  userStartDateTime: string;
  userEndDateTime: string;
  comments: string;
  lastUser: string;

  userStartDateString?: string;
  userStartTimeString?: string;

  userEndDateString?: string;
  userEndTimeString?: string;
}

interface ICommandElement {
  cmdExecutingText?: string;
  cmdExecutedErrorText?: string;
  completedText?: string;
}

/**
 * 
 */
interface IPayrollBreakCommand {
  load?: boolean;

  actionName?: string;
  id?: number;
  breaks?: IPayrollBreakRowData[];
  dataJson?: string;
  driverCode?: string;
  breakType?: string;

  invokeBreakClockInOut?: {};

  invokeDriverUpdateBreak?: {};
  invokeGetPayrollPeriodBreaks?: {};

  viewModel?: IViewModelPayrollBreak;
}

interface IBreakEntryFormViewModel {
  data: IPayrollBreakRowData;

  payrollDate: Date;
  rows: IPayrollBreakRowData[];
  section: IPayrollBreakSectionsViewData;

  startDateVm: IFormInputViewModel;
  startTimeVm: IFormInputViewModel;
  endDateVm: IFormInputViewModel;
  endTimeVm: IFormInputViewModel;
  commentsVm: IFormInputViewModel;

  isValid: boolean;
}

export type ClockInOutActionType = 'add' | 'edit' | 'delete';

export interface IBreakClockInOutActionData {
  id?: number;
  breakType?: number;
  at: string;
  reason?: string;
  endAt?: string;
}

export type ClockInOutBreakAction = {
  [key in ClockInOutActionType]?: IBreakClockInOutActionData;
};

/** 
 * Represents a date and time in the format { date: 'MM-DD-YYYY', time: 'HH:mm' } 
 */
export interface IAtInfo {
  date: string;
  time: string;
}

/** 
 * Represents a location with a title, timestamp, and coordinates 
 */
export interface ILocationInfo {
  title: string;
  subTitle?: string;
  at: IAtInfo;
  lat: number;
  lng: number;
}

/** 
 * Contains row number and whether the row is the first or last in the sequence 
 */
export interface IRowInfo {
  row: number;
  isFirst: boolean;
  isLast: boolean;
}

/** 
 * Represents time and distance gap information between two rows
 */
export interface IGapInfo {
  minutes: number;
  offsetMinutesFrom: number;
  offsetMinutesTo: number;
  crowMiles: number;
  crowMeters: number;
}

/** 
 * A single timeline row consisting of trip info, gaps, and from/to details 
 */
export interface IRow {
  rowInfo: IRowInfo;
  gapInfo: IGapInfo;
  fromInfo: ILocationInfo;
  toInfo: ILocationInfo;
}

/** 
 * Contains the data driver submited for review
 */
export interface IDayInfoReview {
  reportIssues: boolean;
  comment: string;
}

/** 
 * Contains the full list of rows representing the driver’s activity for the day 
 */
export interface IDayInfo {
  rows: IRow[];
  reviewInfo: IDayInfoReview;
}

/** 
 * Represents a break window with a start/end time and compliance info 
 */
export interface IBreakWindow {
  block: number;
  ruleMinutes: number;
  startAt: IAtInfo;
  endAt: IAtInfo;
  isShort: boolean;
  breaks?: IBreak[];
}

/** 
 * Represents a break window with a start/end time and compliance info 
 */
export interface IBreak {
  id: number;
  startAt: { date: string, time: string };
  endAt: { date: string, time: string };
  durationMinutes?: number;
  warningText?: string;
  infoText?: string;
  errorText?: string;
}

/** 
 * Represents a break review info
 */
export interface IBreakInfoReview {
  agree: boolean;
  disagree: boolean;
  comment: string;
}

/** 
 * Describes a break type and all its scheduled windows for the day 
 */
export interface IBreakInfo {
  breakType: number;
  windows: IBreakWindow[];
  breaksAfter?: IBreak[];
  breaksBefore?: IBreak[];
  reviewInfo?: IBreakInfoReview;
}

/** 
 * Describes a sign info windows for the day 
 */
export interface ISignInfo {
  comment: string;
  reviewInfo?: IBreakInfoReview;
}

export interface ITimesheetIssueInfo {
  comment: string;
}

/**
 * Root object that represents the driver's day, including rows, rest, and meal breaks 
 */
export interface IDriverBreakDay {
  dayInfo: IDayInfo;
  restBreakInfo: IBreakInfo;
  mealBreakInfo: IBreakInfo;
  signInfo: ISignInfo;
  timesheetIssueInfo: ITimesheetIssueInfo;
}

/**
 * list of issues descriptions
 */
export interface ITimesheetIssue {
  notPriced: boolean;
  dayTooLong: boolean;
}

